export default __webpack_public_path__ + "static/media/Bad_Idea.aa7e0839.svg";